"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var services_1 = require("../services");
var types_1 = require("../types");
var tiles_1 = require("../tiles");
exports.smartDeck = [
    tiles_1.battle,
    tiles_1.battle,
    tiles_1.battle,
    tiles_1.battle,
    tiles_1.pushBack,
    tiles_1.pushBack,
    tiles_1.pushBack,
    tiles_1.move,
    tiles_1.sniper,
    tiles_1.terror,
    tiles_1.terror,
    tiles_1.smartRipper,
    tiles_1.smartTwister,
    tiles_1.smartNetFighter,
    tiles_1.smartNetFighter,
    tiles_1.smartGaussCannon,
    tiles_1.smartGaussCannon,
    tiles_1.smartGaussCannon,
    tiles_1.smartGolemMK3,
    tiles_1.smartGolemMK3,
    tiles_1.smartCyborg,
    tiles_1.smartCyborg,
    tiles_1.smartTransporter,
    tiles_1.smartTransporter,
    tiles_1.smartTransporter,
    tiles_1.smartBioDroid,
    tiles_1.smartOfficer,
    tiles_1.smartOfficer,
    tiles_1.smartOfficer,
    tiles_1.smartOfficer,
    tiles_1.smartMother,
    tiles_1.smartMother,
    tiles_1.smartScout,
    tiles_1.smartScout
];
exports.smartColor = '#909090';
exports.addSmartArmyData = services_1.addArmyData(types_1.Armies.Smart, exports.smartColor);
exports.smartArmy = {
    color: exports.smartColor,
    deck: exports.smartDeck.map(exports.addSmartArmyData),
    hq: exports.addSmartArmyData(tiles_1.smartHQ)
};
